import styled from "styled-components";

export const SelectItem = styled.div`
    display: flex;
    align-items: center;
    color: #e9e9ea;
    border-radius: 24px;
    border: 2px solid #454650;
    padding: 5px 12px;
    margin: 6px 6px;
    cursor: pointer;
    background-color: #2b2d39;

    div {
        color: #e9e9ea !important;
    }

    img,
    svg {
        margin-right: 4px;
    }

    &.active {
        background-color: #e9e9ea;

        div {
            color: #000000 !important;
        }

        img,
        svg {
            filter: invert(1);
        }
    }
`;
